/* KimiKim product-page Wholesale Hub variant price synchronizer */
(function () {
  'use strict';

  function moneyTextToCents(text) {
    if (!text) return null;

    var compact = String(text).replace(/\s+/g, '');
    var numeric = compact.replace(/[^0-9,.-]/g, '');
    if (!numeric) return null;

    var lastDot = numeric.lastIndexOf('.');
    var lastComma = numeric.lastIndexOf(',');
    var decimalSeparator = null;

    if (lastDot !== -1 && lastComma !== -1) {
      decimalSeparator = lastDot > lastComma ? '.' : ',';
    } else if (lastDot !== -1) {
      if (numeric.length - lastDot - 1 === 2) decimalSeparator = '.';
    } else if (lastComma !== -1) {
      if (numeric.length - lastComma - 1 === 2) decimalSeparator = ',';
    }

    if (decimalSeparator) {
      var thousandsSeparator = decimalSeparator === '.' ? ',' : '.';
      numeric = numeric.split(thousandsSeparator).join('');
      if (decimalSeparator === ',') numeric = numeric.replace(',', '.');
    } else {
      numeric = numeric.replace(/[.,]/g, '');
    }

    var amount = Number(numeric);
    if (!Number.isFinite(amount)) return null;
    return Math.round(amount * 100);
  }

  function getWholesalePriceFromOption(container, variantId) {
    if (!container || !container.querySelector) return null;

    var select = container.querySelector('[data-product-select]');
    if (!select || !select.options) return null;

    var option = Array.prototype.find.call(select.options, function (item) {
      return String(item.value) === String(variantId);
    });
    if (!option) return null;

    var text = option.textContent || '';
    var separatorIndex = text.lastIndexOf(' - ');
    if (separatorIndex === -1) return null;

    return moneyTextToCents(text.slice(separatorIndex + 3));
  }

  function applyImmediateWholesaleVariantPrice(event) {
    var detail = event.detail || {};
    var variant = detail.variant;
    if (!variant || !event.target) return;

    var wholesalePrice = getWholesalePriceFromOption(event.target, variant.id);
    if (wholesalePrice === null) return;

    if (typeof variant._kimiRetailPrice === 'undefined') {
      variant._kimiRetailPrice = Number(variant.price) || 0;
      variant._kimiRetailCompareAtPrice = Number(variant.compare_at_price) || 0;
    }

    var retailPrice = variant._kimiRetailPrice;
    var retailCompareAtPrice = variant._kimiRetailCompareAtPrice;

    if (wholesalePrice !== retailPrice) {
      variant.price = wholesalePrice;
      variant.compare_at_price = retailCompareAtPrice > retailPrice
        ? retailCompareAtPrice
        : retailPrice;
    } else {
      variant.price = retailPrice;
      variant.compare_at_price = retailCompareAtPrice || null;
    }
  }

  document.addEventListener('variantChange', applyImmediateWholesaleVariantPrice, true);
})();
